import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Typography, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterChip from './common/FilterChip.';

export default function FilterAccordian({ children, filters }) {
  return (
    <Grid item xs={12}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              columnGap: 10,
            }}
          >
            <Typography>Filters:</Typography>
            {filters?.length > 0 ? (
              filters?.length >= 4 ? (
                <FilterChip
                  label={'Multiple Filters'}
                  key={0}
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'unset',
                    paddingRight: '12px',
                  }}
                />
              ) : (
                filters.map((f, i) => <FilterChip label={f} key={i} />)
              )
            ) : (
              <Typography></Typography>
            )}
          </div>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: '1rem 2rem 3rem' }}>
          {children}
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
//  show up to 5 filters then count of remaining
